import { mainBodyStoreUnionMultiSelect } from '../../components/Business/QueryFieldPresets';
import type { ForgeQuery } from '../../components/ForgeQueryBuilder';
import { FieldConfig } from '../../components/ForgeQueryBuilder';
import { useBrands, useShopMap, useMainBodyMap } from '../../services/store/organization.store';
import { PurchaseTabScene } from '../../types/process/purchase';

export const getDefaultQuery = (scene?: PurchaseTabScene | string): ForgeQuery => {
  return {};
};

export const useDefaultQueryFields = (scene?: PurchaseTabScene | string): FieldConfig[] => {
  const { brandList: brands } = useBrands();
  const { shopList } = useShopMap();
  const { mainBodyList } = useMainBodyMap();

  const fieldMap: Record<string, FieldConfig> = {
    order_no: {
      key: 'order_no',
      label: '订单号',
      type: 'string',
      placeholder: '精准搜索',
    },
    purchase_no: {
      key: 'purchase_no',
      label: '采购单号',
      type: 'string',
      placeholder: '精准搜索',
    },
    brand_id: {
      key: 'brand', // Use 'brand' string field directly if possible, or keep brand_id for mapping
      label: '品牌',
      type: 'multiSelect' as const,
      operators: ['eq'],
      options: brands.map(brand => ({ label: brand.name, value: brand.name })), // Value is name string
      width: 200,
      placeholder: '品牌',
    },
    store_id: {
      ...mainBodyStoreUnionMultiSelect(mainBodyList, shopList, 'store_id'),
    },
    supplier_name: {
      key: 'supplier_name',
      label: '供应商',
      type: 'select',
      operators: ['eq'],
      options: [
        { label: '郑州激活', value: '郑州激活' },
        { label: '郑州星宇', value: '郑州星宇' },
      ],
      width: 200,
      placeholder: '供应商',
    },
    payment_type: {
      key: 'payment_type',
      label: '支付方式',
      type: 'select',
      operators: ['eq'],
      options: [
        { label: '单个支付', value: '单个支付' },
        { label: '合并支付', value: '合并支付' },
      ],
      width: 150,
      placeholder: '支付方式',
    },
    lock_status: {
      key: 'lock_status',
      label: '是否有锁',
      type: 'select',
      operators: ['eq'],
      options: [
        { label: '有锁', value: 1 },
        { label: '无锁', value: 2 },
      ],
      width: 150,
      placeholder: '是否有锁',
    },
    activation_status: {
      key: 'activation_status',
      label: '是否激活',
      type: 'select',
      operators: ['eq'],
      options: [
        { label: '是', value: 1 },
        { label: '否', value: 2 },
      ],
      width: 150,
      placeholder: '是否激活',
    },
    created_at: {
      key: 'created_at',
      label: '需求提交时间',
      type: 'date',
      operators: ['between'],
      format: 'YYYY-MM-DD',
      placeholder: ['开始日期', '结束日期'],
      width: 260,
    },
    declare_time: {
      key: 'declare_time',
      label: '申报时间',
      type: 'date',
      operators: ['between'],
      format: 'YYYY-MM-DD',
      placeholder: ['开始时间', '结束时间'],
      width: 260,
    },
    quoted_time: {
      key: 'quoted_time',
      label: '报价提交时间',
      type: 'date',
      operators: ['between'],
      format: 'YYYY-MM-DD',
      placeholder: ['开始日期', '结束日期'],
      width: 260,
    },
  };

  const sceneFieldsMap: Record<string, string[]> = {
    [PurchaseTabScene.QuotePending]: [
      'order_no', 'brand_id', 'store_id', 'lock_status', 'activation_status', 'created_at'
    ],
    [PurchaseTabScene.DeliveryPending]: [
      'purchase_no', 'order_no', 'brand_id', 'store_id', 'lock_status', 'activation_status', 'quoted_time'
    ],
    [PurchaseTabScene.Undeclared]: [
      'purchase_no', 'order_no', 'brand_id', 'store_id', 'lock_status', 'activation_status', 'quoted_time'
    ],
    [PurchaseTabScene.Declared]: [
      'purchase_no', 'order_no', 'brand_id', 'store_id', 'supplier_name', 'declare_time'
    ],
    [PurchaseTabScene.Finished]: [
      'purchase_no', 'order_no', 'brand_id', 'store_id', 'supplier_name', 'declare_time', 'payment_type'
    ],
    [PurchaseTabScene.FinancialPending]: [
      'purchase_no', 'order_no', 'brand_id', 'store_id', 'supplier_name', 'declare_time'
    ],
    default: [
      'purchase_no', 'order_no', 'brand_id', 'store_id', 'lock_status', 'activation_status', 'created_at'
    ],
  };

  const fields = sceneFieldsMap[scene as string] || sceneFieldsMap.default;
  return fields.map(key => fieldMap[key]).filter(Boolean);
};



